





































































/* note
 * kensain, seibishi: single select
 * hojoSeibishi: multiple select
 * hojoSeibishi + seibishi <= maxSeibishiHojoStaffCount
*/
import { Component, Vue, Watch } from "vue-property-decorator";
import Number from "@/shared/filters/Number";
import Header from "@/components/Header.vue";
import SubHeader from "@/components/SubHeader.vue";
import { InspectKbn } from "@/model/InspectKbn";
import { InspectStaff } from "@/model/InspectStaff";
import { InspectDetail } from "@/model/InspectDetail";
import requestService from "@/service/requestService";
import { IppanSeibiService } from "@/service/IppanSeibiService";
import { InspectionDetailStoreService } from "@/service/InspectionDetailStoreService";
import { InspectionShakenShuruiDetailStoreService } from "@/service/InspectionShakenShuruiDetailStoreService";
import { InspectionJizenDetailStoreService } from "@/service/InspectionJizenDetailStoreService";
import { InspectionInspectLineDetailStoreService } from "@/service/InspectionInspectLineDetailStoreService";
import { InspectionLiftUseDetailStoreService } from "@/service/InspectionLiftUseDetailStoreService";
import { InspectionStaffKensainDetailStoreService } from "@/service/InspectionStaffKensainDetailStoreService";
import { InspectionStaffSeibishiDetailStoreService } from "@/service/InspectionStaffSeibishiDetailStoreService";
import { InspectionStaffHojoDetailStoreService } from "@/service/InspectionStaffHojoDetailStoreService";
import { InspectionOptionDetailStoreService } from "@/service/InspectionOptionDetailStoreService";
import { InspectionCouponDetailStoreService } from "@/service/InspectionCouponDetailStoreService";
import { InspectionProposalDetailStoreService } from "@/service/InspectionProposalDetailStoreService";
import { InspectionTokutenDetailStoreService } from "@/service/InspectionTokutenDetailStoreService";
import { Action, Getter } from "vuex-class";
import { SknUketsukeExtends } from "@/model/SknUketsukeExtends";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import { MESSAGE } from "@/model/Message";
import { InspectionDetailState } from "@/store/modules/InspectionDetailStore";
import { LiftUse } from "@/model/LiftUse";
import { Utils } from "@/service/util";
import ReservationDetailState from "@/store/reservation/state";
import { SocketControllers } from "@/service/SocketControllers";
import store from "@/store";
import { InspectionSelectionSync } from "@/service/InspectionSelectionSync";
import { SelectionNotificationReceiver } from "@/service/SelectionNotificationReceiver";

@Component({
  filters: {
    Number
  },
  components: {
    Header,
    SubHeader,
    ConfirmDialog
  }
})
export default class InspectionDetailContent extends Vue {

// =====================================
// Props
// =====================================

// =====================================
// Vuex
// =====================================

  @Action("setProgressState", { namespace: "SubHeader" })
  setProgressState: any;
  @Getter("stateId", { namespace: "SubHeader" })
  stateId: number;
  @Getter("uketsukeCd", { namespace: "ReservationDetail" })
  uketsukeCd: string;
  @Getter("sknUketsukeExtends", { namespace: "ReservationDetail" })
  sknUketsukeExtends: SknUketsukeExtends;
  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;
  @Getter("yoyakuNo", { namespace: "ReservationDetail" })
  yoyakuNo: string;
  @Getter("sknSeibiShubetsuKbn", { namespace: "ReservationDetail" })
  sknSeibiShubetsuKbn: number;

  @Getter("currentState", { namespace: "ReservationDetail" })
  reservationState: ReservationDetailState;

  @Action("clearState", { namespace: "Buhin" })
  clearBuhin: any;

  @Action("clearState", { namespace: "NisseirenWorkBuhin" })
  clearNisseirenWorkBuhin: any;

  @Getter("isCanJizenMitsumori", { namespace: "FunctionSetting" })
  isCanJizenMitsumori: any;

  @Getter("currentState", { namespace: "FunctionSetting" })
  functionSettingState: any;

  @Getter("isNextageCustom", { namespace: "FunctionSetting" })
  isNextageCustom: any;

  @Getter("isExcludingTax", { namespace: "FunctionSetting" })
  isExcludingTax: any;

  @Getter("isUseIppanSeibi", { namespace: "FunctionSetting" })
  isUseIppanSeibi: boolean | null; // システム設定A 一般整備見積
  @Getter("isInspectionLessInput", { namespace: "FunctionSetting" })
  isInspectionLessInput: boolean | null; // システム設定B 車検の検査構成画面の入力を減らす

  @Getter("selectComboListFactory", { namespace: "FunctionSetting" })
  selectComboListFactory: any;
  @Getter("selectComboListUser", { namespace: "FunctionSetting" })
  selectComboListUser: any;

  @Getter("couponLabel", { namespace: "FunctionSetting" })
  couponLabel: string;
  @Getter("optionLabel", { namespace: "FunctionSetting" })
  optionLabel: string;

// =====================================
// Refs / Service
// =====================================
  $refs!: {
    errorDialog: ConfirmDialog;
  };

  inspectionDetailStore: InspectionDetailStoreService =
    new InspectionDetailStoreService();
  public utils: Utils = new Utils();

// =====================================
// State / function
// =====================================

  isUserMode: boolean = false;

  reqService: any;
  ippanSeibiService: IppanSeibiService;
  
  inspectionDetail: InspectDetail = {
    kensain: [],
    seibishi: [],
    hojoSeibishi: []
  };
  errorMsg: string = "";

  staffSize: number = 6;

  loadingText: string = MESSAGE.Loading;
  loading: boolean = false;
  // listStaffSelected: any = [];
  titleAsk: string = "";
  isRestart: boolean = false;

  // 検査構成で何を表示するか、という設定
  inspectionContentList: any = [];

  // 各サービスを持たせる
  inspectionServiceList: any = [];
  couponDataPromise: Promise<any> | null = null;

  isExitSetInspection: boolean = false;
  selectionSync = new InspectionSelectionSync();
  selectionSocket: SocketControllers | null = null;
  selectionReady = false;
  selectionReceiver = this.createSelectionReceiver();

  // Vueに束縛されたメソッド内で生成し、コールバックが実インスタンスを参照するようにする。
  createSelectionReceiver() {
    return new SelectionNotificationReceiver({
      context: () => ({
        request: this.reqService, id: this.uketsukeExtendsId,
        kbn: this.currentSknSeibiShubetsuKbn
      }),
      apply: snapshot => this.applySelectionSnapshot(snapshot),
      onError: () => this.$notify.error({ title: "更新エラー", message: "他画面の変更を取得できませんでした。画面を開き直してください。" }),
      ready: () => this.selectionReady,
    });
  }

  get selectionDisposed() { return this.selectionReceiver.disposed; }
  isSetScrollEvent: boolean = false;
  scrollEventHandlers: any = {};

  created() {
    if (this.$route.meta == "user") {
      this.isUserMode = true;
    }
    if (window.outerHeight < 864) {
      this.staffSize = 5;
    }
    this.reqService = new requestService();
    this.ippanSeibiService = new IppanSeibiService();

    this.setInspectionContentList();
  }

  mounted() {
    this.$nextTick(() => {
      this.setScrollEvent();
    });
  }

  beforeDestroy() {
    this.selectionReceiver.dispose();
    this.inspectionContentList.forEach((inspection: any) => {
      const list = document.getElementById(`list-${inspection.comboId}`);
      const scrollEventHandler = this.scrollEventHandlers[inspection.comboId];
      if (list && scrollEventHandler) {
        list.removeEventListener("scroll", scrollEventHandler);
      }
    });
  }

  /*
   * 初期化関数
   * ( createdやmountedで1回だけ実行される必要があるが
   *   特定のパラメータが足りない時は実行順序を前後させる必要がある処理 )
   */
  @Watch("functionSettingState.isCanJizenMitsumori")
  setInspectionContentList() {
    // 必要な値が未セット、または初期化済みなら何もしない
    const isCanJizenMitsumori = this.functionSettingState
      ? this.functionSettingState.isCanJizenMitsumori
      : null;
    if (isCanJizenMitsumori == null || this.isExitSetInspection) { return; }
    this.isExitSetInspection = true;

    // ここでinspectionContentListの初期化動作をする
    if (this.$route.meta == "user") {
      this.inspectionContentList = this.selectComboListUser;
    } else {
      this.inspectionContentList = this.selectComboListFactory;
    }


    // 各リストのラベル生成
    this.inspectionContentList.forEach((contentData: any, index: number) => {
      // 各選択肢用のサービスを宣言
      let serviceData: any = {
        "key": contentData.key,
        "comboId": contentData.comboId,
        "service": null
      };
      // inspectionContentList追加時に必須になる基本分岐設定 (全部で2か所ある)
      switch (contentData.comboId) {
        case "shakenShurui":
          serviceData.service = new InspectionShakenShuruiDetailStoreService();
          break;
        case "inspectLine":
          serviceData.service = new InspectionInspectLineDetailStoreService();
          break;
        case "liftUse":
          serviceData.service = new InspectionLiftUseDetailStoreService();
          break;
        case "staffKensain":
          serviceData.service = new InspectionStaffKensainDetailStoreService();
          break;
        case "staffSeibishi":
          serviceData.service = new InspectionStaffSeibishiDetailStoreService();
          break;
        case "staffHojo":
          serviceData.service = new InspectionStaffHojoDetailStoreService();
          break;
        case "jizen":
          serviceData.service = new InspectionJizenDetailStoreService();
          break;
        case "option":
          serviceData.service = new InspectionOptionDetailStoreService();
          break;
        case "coupon":
          serviceData.service = new InspectionCouponDetailStoreService();
          break;
        case "proposal":
          serviceData.service = new InspectionProposalDetailStoreService();
          break;
        case "tokuten":
          serviceData.service = new InspectionTokutenDetailStoreService();
          break;
        default:
          break;
      }
      if (!serviceData.service) { return; }
      this.inspectionServiceList.push(serviceData);

      // ラベル名を設定
      let comboNm1 = contentData.comboNm1;
      if( contentData.comboId == "shakenShurui" ) {
        comboNm1 = this.ippanSeibiService.getIppanSeibiLabel(comboNm1);
      }
      if( contentData.comboId == "option" ) {
        comboNm1 = this.optionLabel;
      }
      if( contentData.comboId == "coupon" ) {
        comboNm1 = this.couponLabel;
      }
      contentData.comboLabel = "" + (index + 1) + ". " + comboNm1 + contentData.comboNm2;
    });

    this.connectSelectionSocket();
    this.initData().then(() => {
      if (this.selectionDisposed) { return; }
      this.selectionReady = true;
      this.selectionReceiver.resume();
    }).catch(() => {
      this.$notify.error({ title: "取得エラー", message: "検査構成を取得できませんでした。画面を開き直してください。" });
    });

    this.getWorkProgressState();

    // inspectionContentListの初期化動作は未実装なので
    // 直接発火する
    this.$nextTick(() => {
      this.setScrollEvent();
    });

  }

  @Watch("inspectionContentList", { deep: true })
  // 選択リストのスクロール状態を監視し、上下ボタンの活性状態を更新する
  setScrollEvent() {
    // 必要な値が未セット、または初期化済みなら何もしない
    const scrollEventHandlers: any = {};
    let isSetAllScrollEvent = true;
    this.inspectionContentList.forEach((inspection: any) => {
      const list = document.getElementById(`list-${inspection.comboId}`);
      if (!list) {
        isSetAllScrollEvent = false;
        return;
      }

      const scrollEventHandler = () => {
        if (list.scrollTop === 0) {
          this.$set(inspection, "prev", true);
        } else {
          this.$set(inspection, "prev", false);
        }
        if (list.clientHeight + list.scrollTop >= list.scrollHeight) {
          this.$set(inspection, "next", true);
        } else {
          this.$set(inspection, "next", false);
        }
      };
      list.addEventListener("scroll", scrollEventHandler);
      scrollEventHandlers[inspection.comboId] = scrollEventHandler;
    });
    if (!isSetAllScrollEvent) { return; }

    this.scrollEventHandlers = scrollEventHandlers;
    this.isSetScrollEvent = true;

    /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
    this.onChangeSeibiMenuCd();
    /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */
  }

  // 指定された検査構成項目に対応する選択サービスを取得する
  getInspectionService(comboId: string) {
    const serviceData = this.inspectionServiceList.find((data: any) => {
      return data.comboId === comboId;
    });
    if (!serviceData) {
      return null;
    }
    return serviceData.service;
  }

  // 整備種別区分が未設定の場合に互換用の0を返す
  get currentSknSeibiShubetsuKbn() {
    if (this.sknSeibiShubetsuKbn !== undefined && this.sknSeibiShubetsuKbn !== null) {
      return this.sknSeibiShubetsuKbn;
    }
    return 0;
  }

  // 検査構成の保存済み状態を読み込み、各選択サービスへ初期選択を反映する
  async initData() {
    if (this.inspectionState.hasData) {
      const data = await this.reqService.getInsectionDetail(this.uketsukeExtendsId, this.currentSknSeibiShubetsuKbn);
      this.selectionSync.remember("shakenShurui", data.shakenShuruiSeibiMenuCd);
      const baseline = this.inspectionState.configurationBaseline;
      if (baseline) { this.rememberConfiguration(baseline); }
      await this.getData();
      this.applyConfiguration(data);
    } else {
      // 過去の検査構成選択内容を呼び出し
      return this.reqService
        .getInsectionDetail(this.uketsukeExtendsId, this.currentSknSeibiShubetsuKbn)
        .then(async (data: any) => {
          this.selectionSync.remember("shakenShurui", data.shakenShuruiSeibiMenuCd);
          this.rememberConfiguration(this.inspectionState.configurationBaseline || data);
          this.setProgressState({
            stateId: data.workProgressStateId,
            stateNm: data.workProgressStateNm
          });
          this.inspectionDetailStore.setProgressState({
            stateId: data.workProgressStateId,
            stateNm: data.workProgressStateNm
          });
          this.inspectionDetailStore.setMaxSeibishiHojoStaffCount(data.maxSeibishiHojoStaffCount);
          this.inspectionDetail = {
            hojoSeibishi: data.hojoSeibishi,
            inspectLineCd: data.inspectLineCd,
            inspectLineNm: data.inspectLineNm,
            kensain: data.kensain,
            liftUse: data.liftUse,
            seibishi: data.seibishi,
            shakenShuruiSeibiMenuCd: data.shakenShuruiSeibiMenuCd,
            shakenShuruiNm: data.shakenShuruiNm
            , jizenCd: data.jizenCd,
            jizenNm: data.jizenNm,
            option: data.option,
            coupon: data.coupon,
            proposal: data.proposal,
            tokuten: data.tokuten,
            maxSeibishiHojoStaffCount: this.maxSeibishiHojoStaffCount
          };

          // 取得済みの検査構成選択内容を各サービスの選択状態へ反映する
          this.inspectionServiceList.forEach((serviceData: any) => {
           const inspectionService = serviceData.service;
           inspectionService.applyInitialInspectionDetail(
             data,
             this.inspectionDetail,
             this.isCanJizenMitsumori
           );
          });

          await this.getData();
          this.applyConfiguration(data);
          if (data.updatedAt && this.checkAllSelected()) {

            // 既に上限人数を超えて設定されている時は警告を出す
            if (data.seibishi.length + data.hojoSeibishi.length > this.maxSeibishiHojoStaffCount) {
              this.errorMsg = MESSAGE.ExceedStaffSeleced;
              this.$refs.errorDialog.onOpen();
            } else if (!this.isUserMode) {
              this.$emit("setDisabledStart", false);
            }
          }
        });
    }
  }

  // 対象の4通知を購読し、再接続時は最新状態を取得する。
  connectSelectionSocket() {
    this.selectionSocket = new SocketControllers(this);
    const socket = this.selectionSocket;
    socket.onReconnect(() => this.selectionReceiver.receive());
    ["updateCourseSubscription", "optionSubscription", "couponSubscription", "inspectSubscriptionDetail"]
      .forEach(key => socket.socketEntry(key, this.refreshSelections));
    socket.connectSocket();
  }

  refreshSelections(frame?: any) {
    return this.selectionReceiver.receive(frame && this.utils.getWSData(frame));
  }

  applySelectionSnapshot(snapshot: any) {
    const { detail, option, coupon } = snapshot;
    this.applyConfiguration(detail);
    const course = this.getInspectionService("shakenShurui");
    if (course && this.selectionSync.changed("shakenShurui", detail.shakenShuruiSeibiMenuCd)) {
      this.inspectionDetail.shakenShuruiSeibiMenuCd = detail.shakenShuruiSeibiMenuCd;
      this.inspectionDetail.shakenShuruiNm = detail.shakenShuruiNm;
      course.applyInitialInspectionDetail(detail);
      course.setList(course.list.map((item: any) => ({
        ...item, selected: String(item.seibiMenuCd) === String(detail.shakenShuruiSeibiMenuCd) ? "1" : "0"
      })));
      if (detail.shakenShuruiSeibiMenuCd) {
        course.changeSeibiMenuCdSelection(false, this.sknSeibiShubetsuKbn);
      }
      course.checkDisableStart(course.list);
    }
    this.selectionSync.remember("shakenShurui", detail.shakenShuruiSeibiMenuCd);
    ["option", "coupon", "proposal", "tokuten"].forEach(key => {
      const response = key === "option" ? option : coupon;
      const items = response[key] && response[key].items || [];
      const service = this.getInspectionService(key);
      if (service && this.selectionSync.changed(key, items)) {
        // 古い選択をORしない。全解除もサーバーどおり反映する。
        service.setInitialList(this.utils.deepCopy(response), [], true);
        service.setStartInspectDetail(this.inspectionDetail);
      }
      this.selectionSync.remember(key, items);
    });
    this.checkDisableStartAfter();
  }

  rememberConfiguration(detail: any) {
    const baseline: any = {};
    ["inspectLineCd", "liftUse", "jizenCd", "kensain", "seibishi", "hojoSeibishi"].forEach(key => {
      baseline[key] = this.utils.deepCopy(detail[key] == null ? null : detail[key]);
      this.selectionSync.remember(key, detail[key]);
    });
    store.dispatch("InspectionDetail/setConfigurationBaseline", baseline);
  }

  applyConfiguration(detail: any) {
    // 旧形式の通知では未配信項目を解除扱いにしない。
    if (!Object.prototype.hasOwnProperty.call(detail, "inspectLineCd")) { return; }
    const changedStaff = this.selectionSync.changed("seibishi", detail.seibishi)
      || this.selectionSync.changed("hojoSeibishi", detail.hojoSeibishi);
    const entries = [
      ["inspectLineCd", "inspectLine"], ["liftUse", "liftUse"], ["jizenCd", "jizen"],
      ["kensain", "staffKensain"], ["seibishi", "staffSeibishi"], ["hojoSeibishi", "staffHojo"]
    ];
    entries.forEach(([key, comboId]) => {
      const changed = key === "seibishi" || key === "hojoSeibishi"
        ? changedStaff : this.selectionSync.changed(key, detail[key]);
      const service = this.getInspectionService(comboId);
      if (!changed || !service) { return; }
      this.$set(this.inspectionDetail, key, this.utils.deepCopy(detail[key] == null ? null : detail[key]));
      service.setNowSelected(false);
      const list = this.utils.deepCopy(service.list);
      if (["kensain", "seibishi", "hojoSeibishi"].indexOf(key) >= 0) {
        const staff = detail[key] || [];
        staff.forEach((item: any) => {
          if (!list.some((row: any) => String(row.staffCd) === String(item.staffCd))) { list.push(item); }
        });
        service.setInitialList(list, staff, this.isDeSelStaff(key === "seibishi"));
      } else {
        if (key === "liftUse") { service.applyInitialInspectionDetail(detail); }
        service.setInitialList(list, detail[key]);
        if (key !== "liftUse") {
          service.setCd(detail[key]);
          service.checkDisableStart(service.list);
          const name = key === "inspectLineCd" ? "inspectLineNm" : "jizenNm";
          this.$set(this.inspectionDetail, name, detail[name]);
        }
      }
    });
    this.rememberConfiguration(detail);
    this.checkDisableStartAfter();
  }

  // リフトで「選択無し」を扱う必要があるか返す
  get hasDeSelLift() {
    // 一般整備または「車検の検査構成画面の入力を減らす」がONの場合は、リフトに「選択無し」を追加、初期選択
    return this.ippanSeibiService.isIppanSeibi || this.isInspectionLessInput;
  }





  // 検査構成に表示する各選択肢リストを取得する
  async getData() {
    const promiseList: Array<Promise<any>> = [];
    // 整備士の「選択無し」判定処理を先に行う
    const isDeSelSeibishi = this.isDeSelStaff(true);
    const isDeSelOtherStaff = this.isDeSelStaff(false);

    // 各領域の選択肢データを読み込み
    this.inspectionServiceList.forEach((serviceData: any) => {
      const inspectionService = serviceData.service;
      let getDataList: any = null;

      // inspectionContentList追加時に必須になる基本分岐設定 (全部で2か所ある)
      switch (serviceData.comboId) {
        case "shakenShurui":
          const shakenShuruiService = inspectionService;
          getDataList = shakenShuruiService.getDataList(() => {
            // 入庫予約内容データリストから車検種類の紐づけ情報を確認、自動選択させる
            // extreme側の用語では「受付作業種別と整備メニュー」のマスタ上の紐づけ情報
            return this.reqService.getWorkShubetsu().then((res: any) => {
              shakenShuruiService.setDefaultSeibiMenuFromWorkShubetsu(res, this.reservationState);
              return shakenShuruiService.getShakenShurui(
                () => this.reqService.getSeibiMenuList(),
                this.inspectionDetail,
                this.isUseIppanSeibi,
                this.sknSeibiShubetsuKbn
              );
            });
          });
          break;
        case "inspectLine":
          getDataList = inspectionService.getDataList(
            () => this.reqService.getKbnSkns("skn_inspect_line"),
            this.inspectionDetail.inspectLineCd
          );
          break;
        case "liftUse":
          getDataList = inspectionService.getDataList(
            () => this.reqService.getLiftUse(),
            this.inspectionDetail.liftUse
          );
          break;
        case "staffKensain":
          getDataList = inspectionService.getDataList(
            () => this.reqService.getStaffKensain(),
            this.inspectionDetail.kensain,
            isDeSelOtherStaff
          );
          break;
        case "staffSeibishi":
          getDataList = inspectionService.getDataList(
            () => this.reqService.getStaffSeibishi(),
            this.inspectionDetail.seibishi,
            isDeSelSeibishi
          );
          break;
        case "staffHojo":
          getDataList = inspectionService.getDataList(
            () => this.reqService.getStaffHojoseibishi(),
            this.inspectionDetail.hojoSeibishi,
            isDeSelOtherStaff
          );
          break;
        case "jizen":
          getDataList = inspectionService.getDataList(
            () => this.reqService.getKbnSkns("skn_jizen"),
            this.inspectionDetail.jizenCd
          );
          break;
        case "option":
          getDataList = inspectionService.getDataList(
            () => this.reqService.getOption(this.uketsukeExtendsId, this.currentSknSeibiShubetsuKbn)
            .then((data: any) => {
              this.selectionSync.remember("option", data.option.items);
              return data;
            }),
            this.inspectionDetail.option,
            this.isSavedEmptySelection(this.inspectionDetail.option)
          );
          break;
        case "coupon":
          getDataList = inspectionService.getDataList(
            () => this.getCouponData(),
            this.inspectionDetail.coupon,
            this.isSavedEmptySelection(this.inspectionDetail.coupon)
          );
          break;
        case "proposal":
          getDataList = inspectionService.getDataList(
            () => this.getCouponData(),
            this.inspectionDetail.proposal,
            this.isSavedEmptySelection(this.inspectionDetail.proposal)
          );
          break;
        case "tokuten":
          getDataList = inspectionService.getDataList(
            () => this.getCouponData(),
            this.inspectionDetail.tokuten,
            this.isSavedEmptySelection(this.inspectionDetail.tokuten)
          );
          break;
        default:
          break;
      }
      if (!getDataList) {
        return;
      }
      if (getDataList.promise) {
        promiseList.push(getDataList.promise);
      }
      if (getDataList.hasExistingList) {
        this.checkDisableStartAfter();
      }
    });

    return Promise.all(promiseList);
  }

  // 初回未選択と「選択無し」保存済みをworkProgressStateIdで判別する
  isSavedEmptySelection(selectedList: any) {
    return this.stateId !== -1 && this.stateId !== 0
      && Array.isArray(selectedList) && selectedList.length === 0;
  }

  // クーポン画面系のデータを読み込む。coupon/proposal/tokutenで同じAPI結果を使い回す。
  getCouponData() {
    if (!this.couponDataPromise) {
      this.couponDataPromise = this.reqService.getCoupon(
        this.uketsukeExtendsId,
        this.currentSknSeibiShubetsuKbn
      ).then((data: any) => {
        ["coupon", "proposal", "tokuten"].forEach(key => {
          this.selectionSync.remember(key, data[key] && data[key].items);
        });
        return data;
      });
    }
    return this.couponDataPromise;
  }

  /**
   * getInsectionDetailで取得した検査員、整備士、補助整備士が空の場合に、「選択無し」か未選択かを判別する。
   * もともとの通常版の仕様：スタート前なら未選択、スタート済みなら「選択無し」
   * 標準化版の仕様        ：ネクステージの場合はスタート前でも「選択無し」
   *                         一般整備または「車検の検査構成画面の入力を減らす」がONの場合は、検査員または補助整備士はスタート前でも「選択無し」
   * @return boolean true:「選択無し」 false:未選択
   */
  isDeSelStaff(isSeibishi: boolean): boolean {
    return this.isNextageCustom || (
      (this.ippanSeibiService.isIppanSeibi || this.isInspectionLessInput) && !isSeibishi) || this.stateId > 0;
  }

  // スタッフ選択時メッセージ文
  onInprogressStaff(staffType: string , staff: InspectStaff) {
    return `作業中の${staffType}：${staff.staffNm}さんを選択しました。`;
  }

  // 各リストから画面表示用の情報に加工したものを出力する
  getTargetList(comboId: string) {
    const inspectionService = this.getInspectionService(comboId);
    if (!inspectionService || !inspectionService.getTargetList) { return []; }
    return inspectionService.getTargetList();
  }

  // 指定項目について選択済みかどうかを判断する
  checkNowSelected(comboId: string) {
    const inspectionService = this.getInspectionService(comboId);
    return inspectionService ? inspectionService.nowSelected : false;
  }

  // 全体の選択状態からスタートボタンの活性状態を親へ通知する
  checkDisableStartAfter() {
    if (this.isUserMode) {
      this.$emit("setDisabledStart", true);
    } else {
      // 全部がtrueだと親にfalseが帰って次に進むボタンのロックが外れる
      this.$emit("setDisabledStart", !this.checkAllSelected());
    }
  }

  // 未選択の項目が残っているかどうか調査
  checkAllSelected() {
    let checker: boolean = true;
    this.inspectionServiceList.forEach((serviceData: any) => {
      const inspectionService = serviceData.service;
      if (!inspectionService.nowSelected) { checker = false; }
    });
    return checker;
  }

  // 工場側の車検「スタート」ボタンを押したときの構成保存動作
  startInspect() {
    this.loading = true;

    this.inspectionDetail.uketsukeCd = this.uketsukeCd;
    this.inspectionDetail.uketsukeExtendId = this.uketsukeExtendsId;
    this.inspectionDetail.yoyakuNo = this.yoyakuNo;
    this.inspectionDetail.updatedAt = this.sknUketsukeExtends.updatedAt;
    this.inspectionDetail.sknSeibiShubetsuKbn = this.currentSknSeibiShubetsuKbn;
    // 各要素の選択も読み込む
    this.inspectionServiceList.forEach((serviceData: any) => {
      const inspectionService = serviceData.service;
      if (!inspectionService || !inspectionService.setStartInspectDetail) { return; }
      const isChangedShakenShurui = inspectionService.setStartInspectDetail(this.inspectionDetail);
      if (serviceData.comboId == "shakenShurui" && isChangedShakenShurui) {
        this.clearBuhin();
        this.clearNisseirenWorkBuhin();
      }
    });

    let saveData = this.utils.deepCopy(this.inspectionDetail);
    this.reqService.saveInsectionDetail(saveData).then( // sendSocket:ソケット仮26
    /** 2021-10-12 sh #7467 it does not check if jizen does not use. [END] */
      (res: any) => {
        this.inspectionDetailStore.save();
        /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
        if (res && res.body) {
          this.getInspectionService("shakenShurui").applyInitialInspectionDetail(res.body);
        }
        /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */
        this.reqService.postNavigation(this.uketsukeExtendsId);
        if (!this.isRestart) {
          // 「スタート」初回の時の限定動作
          let inspectionDetail: InspectDetail = {
            kensain: []
            , seibishi: []
            , hojoSeibishi: []
            , uketsukeExtendId: this.uketsukeExtendsId
          };
          this.reqService.updateUketsukeExtendsNyuukoYmd(inspectionDetail).then(
            () => {
              this.loading = false;
              this.$emit("finishStartInspect");
            },
            (resUpdate: any) => {
              this.onStartInspectError(resUpdate);
            }
          );
        } else {
          this.loading = false;
          this.$emit("finishStartInspect");
        }
      },
      (res: any) => {
        this.onStartInspectError(res);
      }
    );
  }

  // スタート処理で発生したエラーをダイアログ表示する
  onStartInspectError(res: any) {
    this.loading = false;
    if (res.status < 500 && res.rsltComment) {
      this.errorMsg = res.rsltComment;
    } else {
      this.errorMsg = MESSAGE.SystemError;
    }
    this.$refs.errorDialog.onOpen();
  }

  // この予約が開始済みかどうかを判断する
  getWorkProgressState() {
    this.reqService.getSubHeaderData(this.uketsukeExtendsId, this.$route.meta).then(
      (res: any) => {
        if (res.sknWorkProgressStateId && res.sknWorkProgressStateId > 0) {
          this.isRestart = true;
        }
      },
      (err: any) => {}
    );
  }

  // 指定項目で「選択無し」ボタンを表示できるか返す
  etcBtn(comboId: string) {
    const inspectionService = this.getInspectionService(comboId);
    if (!inspectionService || !inspectionService.canDeSelect) { return false; }
    return inspectionService.canDeSelect(this.hasDeSelLift);
  }

  // 指定項目が「選択無し」状態か返す
  deSel(comboId: string) {
    const inspectionService = this.getInspectionService(comboId);
    if (!inspectionService || !inspectionService.isDeSelected) { return null; }
    return inspectionService.isDeSelected();
  }

  // 検査構成項目の選択・選択無しクリックを各サービスへ委譲する
  areaClick(comboId: string, data: any) {
    let result: any;
    if (this.isUserMode) {
      return;
    }
    console.log("lll");
    const inspectionService = this.getInspectionService(comboId);
    if (!inspectionService) {
      return;
    }
    let staffName: string = "";
    const contentData = this.inspectionContentList.find((content: any) => content.comboId == comboId);
    if (!contentData) {
      return;
    }
    // リフトメッセージ用
    const isLift = contentData.comboId == "liftUse";
    // スタッフ系メッセージ用
    const isStaffSelect = ["staffKensain", "staffSeibishi", "staffHojo"].indexOf(contentData.comboId) > -1;
    staffName = contentData.comboNm1;

    if (data != null) {
      if (!inspectionService.select) {
        return;
      }
      // 選択処理
      result = inspectionService.select(data, false);

      // 選択結果のメッセージを表示
      if (isLift && result && result.message) {
        this.onMessage(result.message);
      }
      if (isStaffSelect && result && result.inprogressStaff) {
        this.onMessage(this.onInprogressStaff(staffName, result.inprogressStaff));
      }
    } else {
      if (!inspectionService.clickDeSelect) {
        return;
      }
      // 「選択無し」ボタン
      inspectionService.clickDeSelect(this.hasDeSelLift);
    }
    this.checkDisableStartAfter();
  }

  // 指定項目の選択リストを上下へスクロールする
  move(comboId: string, direction: number) {
    const list = document.getElementById(`list-${comboId}`);
    if (list) {
      setTimeout(() => {
        list.scrollTop += 62 * direction;
      });
    }
  }

  // 画面上部に一時メッセージを表示する
  onMessage(msg: string) {
    this.$message({
      message: msg,
      type: "info",
      duration: 700,
      customClass: "msg-top shadow",
      showClose: true
    });
  }

  // 検査構成Storeの現在状態を参照する
  get inspectionState(): InspectionDetailState {
    return this.inspectionDetailStore.currentState;
  }

  // 整備士と補助整備士の合計選択上限値を参照する
  get maxSeibishiHojoStaffCount(): number {
    return this.inspectionDetailStore.effectiveMaxSeibishiHojoStaffCount;
  }

  // サービス内のseibiMenuCdをWatch対象として公開する
  get seibiMenuCd() {
    const shakenShuruiService = this.getInspectionService("shakenShurui");
    return shakenShuruiService ? shakenShuruiService.seibiMenuCd : null;
  }

  @Watch("seibiMenuCd")
  // 整備メニューコード変更時に車検種類一覧の選択状態を同期する
  onChangeSeibiMenuCd() {
    // 通知による更新は比較処理で適用し、共有Storeの変更だけで編集中の選択を戻さない。
    if (this.selectionReady) { return; }
    const shakenShuruiService = this.getInspectionService("shakenShurui");
    if (!shakenShuruiService) {
      return;
    }
    const needsCheckDisableStart = shakenShuruiService.changeSeibiMenuCdSelection(
      this.isUserMode,
      this.sknSeibiShubetsuKbn
    );
    if (needsCheckDisableStart) {
      this.checkDisableStartAfter();
    }
  }

}
